import React, { useEffect } from 'react';
import { FilterProp, FiltersProp, FilterType, SelectedFilterItem } from '@constants/data-table';
import AppliedFiltersList from '@components/appliedFilterList/AppliedFiltersList';
import DataHeaderActions from '@components/dataHeaderActions/DataHeaderActions';
import styles from './templatesActionsHeader.module.scss';
import {
  PIPELINE_TEMPLATES_FILTERS_FIELD_KEYS,
  PIPELINE_TEMPLATES_FILTERS_TAGS_LABEL,
  PIPELINE_TEMPLATES_SORTING_OPTIONS,
  SEARCH_TEMPLATES_PLACEHOLDER,
} from '../constants/pipeline-templates';
import usePipelineTemplates from '../hooks/usePipelineTemplates';

const TemplatesActionsHeader = () => {
  const {
    pipelineTemplatesFiltersValues,
    pipelineTemplatesSortValue,
    selectedPipelineTemplateFilters,
    getPipelineTemplatesFilterTags,
    resetSelectedTemplateFilters,
    selectTemplatesFilters,
    selectTemplatesSortValue,
    selectTemplatesCategory,
    setTemplatesSearchValue,
  } = usePipelineTemplates();

  useEffect(() => {
    getPipelineTemplatesFilterTags();
  }, []);

  const getPipelineTemplatesFilters = (): FiltersProp<FilterType.MULTI_SELECT> => {
    const { tags } = pipelineTemplatesFiltersValues;

    const tagsFilter = {
      type: FilterType.MULTI_SELECT,
      key: PIPELINE_TEMPLATES_FILTERS_FIELD_KEYS.TAGS_ID,
      title: PIPELINE_TEMPLATES_FILTERS_TAGS_LABEL,
      options: tags,
    } as FilterProp<FilterType.MULTI_SELECT>;

    return [tagsFilter];
  };

  const onSearch = (searchValue: string) => {
    selectTemplatesCategory();
    setTemplatesSearchValue(searchValue);
  };

  const onFilterSelectChange = (filterKey: string, items: SelectedFilterItem[]) => {
    selectTemplatesFilters(filterKey, items);
  };

  const onClearAllFilters = () => {
    resetSelectedTemplateFilters();
  };

  const onSortSelectChange = (value: string) => {
    selectTemplatesSortValue(value);
  };

  return (
    <div className={styles.container}>
      <div className={styles.filtersBar}>
        <DataHeaderActions
          filters={getPipelineTemplatesFilters()}
          filterValues={selectedPipelineTemplateFilters}
          onFilterSelectChange={onFilterSelectChange}
          searchAvailable
          onSearch={onSearch}
          searchPlaceholder={SEARCH_TEMPLATES_PLACEHOLDER}
          onSortSelectChange={onSortSelectChange}
          sorting={{
            selectedValue: pipelineTemplatesSortValue,
            options: PIPELINE_TEMPLATES_SORTING_OPTIONS,
          }}
        />
      </div>
      <div className={styles.appliedFiltersBar}>
        <AppliedFiltersList
          filterValues={selectedPipelineTemplateFilters}
          onClearAllFilters={onClearAllFilters}
          onFilterSelectChange={onFilterSelectChange}
        />
      </div>
    </div>
  );
};

export default TemplatesActionsHeader;
